import { render, staticRenderFns } from "./AddDevice.vue?vue&type=template&id=7c07f300&scoped=true"
import script from "./AddDevice.vue?vue&type=script&lang=js"
export * from "./AddDevice.vue?vue&type=script&lang=js"
import style0 from "./AddDevice.vue?vue&type=style&index=0&id=7c07f300&lang=scss"
import style1 from "./AddDevice.vue?vue&type=style&index=1&id=7c07f300&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c07f300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c07f300')) {
      api.createRecord('7c07f300', component.options)
    } else {
      api.reload('7c07f300', component.options)
    }
    module.hot.accept("./AddDevice.vue?vue&type=template&id=7c07f300&scoped=true", function () {
      api.rerender('7c07f300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/identify/dialog/AddDevice.vue"
export default component.exports